import { createPopper } from "@popperjs/core";

document.querySelectorAll("[data-tooltip-target]").forEach((element) => {
  const tooltip = document.querySelector(`#${element.dataset.tooltipTarget}`);

  if (!tooltip) {
    console.error(`Couldn't locate ${element.dataset.tooltipTarget}`);
    return;
  }

  element.addEventListener("mouseover", (event) => {
    tooltip.classList.remove("hidden");

    createPopper(element, tooltip, {
      placement: "top",
    });
  });

  element.addEventListener("mouseout", (event) => {
    tooltip.classList.add("hidden");
  });
});
